export default {

  application: {
    name: '',
    email: '',
    phone: '',
    city: '',
    agreeTOS: false,
    links: [],
    attachments: [],
    additionalFieldResponses: [],
  },

  jobAd: {},

}
